import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  OutputEmitterRef,
  Signal,
  computed,
  input,
  output,
} from '@angular/core';

import { IndustryCatalogType } from '@core/shared/domain';
import { FilterSelectionOption, MultiSelectionGroupComponent, ToggleFilterComponent } from '@core/ui';
import { PlatformCatalogGlobalFilter } from '@mp/content-manager/plattformkataloge/data-access';

import { CATALOG_TYPE_FILTER_OPTIONS } from '../../catalog-type-filter-options';

@Component({
  selector: 'mp-plattformkataloge-filter-area',
  templateUrl: './plattformkataloge-filter-area.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ToggleFilterComponent, MultiSelectionGroupComponent],
})
export class PlattformkatalogeFilterAreaComponent {
  readonly filter: InputSignal<PlatformCatalogGlobalFilter | null> = input<PlatformCatalogGlobalFilter | null>(null);

  readonly dataSources: InputSignal<string[] | null> = input<string[] | null>(null);

  readonly filterChanges: OutputEmitterRef<Partial<PlatformCatalogGlobalFilter>> =
    output<Partial<PlatformCatalogGlobalFilter>>();

  protected readonly dataSourceFilterOptions: Signal<FilterSelectionOption<string>[]> = computed(() =>
    (this.dataSources() ?? []).map((dataSource) => ({ value: dataSource, label: dataSource })),
  );

  protected readonly catalogTypeFilterOptions: FilterSelectionOption<IndustryCatalogType>[] =
    CATALOG_TYPE_FILTER_OPTIONS;

  handleFilterChanges(filter: Partial<PlatformCatalogGlobalFilter>): void {
    this.filterChanges.emit(filter);
  }
}
